import React from 'react';
import { Box, Spinner, Text } from '@chakra-ui/react';

const CustomSpinner = () => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="100vh" flexDirection="column">
      <Spinner size="xl" color="red.500" />
      <Text fontSize="2xl" color="red.500">Mazadat</Text>
      <Text fontSize="2xl" color="black">Masr</Text>
    </Box>
  );
};

export default CustomSpinner;
